import {View} from 'backbone';
import template from 'common-views/custom-fonts-modal.ejs';
import constants from 'Constants.js';
import util from 'util/Util.js';
import $ from 'jquery';

class CustomFontsModalView extends View {
    initialize(opts) {
        super.initialize(opts);
        this.template = template;        
        this.charsNotAllowed = [',', '\'', '"'];
    }

    render() {
        
        return new Promise((resolve, reject) => {
            this.$el.empty();
            this.$el.html(template(this.model.toJSON()));
            $('body').append(this.$el);
            
            this.delegateEvents();

            $(constants.DIALOG_ID).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: 'auto',
                width: 400,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'Ok',
                        'class': 'btn-select-item',
                        click: () => {
                            const customFonts = this.processCustomFonts();
                            resolve({CustomFonts: customFonts});
                            this.closeModal();
                        }
                    },
                    {
                        'text': 'Cancel',
                        click: () => {
                            resolve();
                            this.closeModal();
                        }
                    }
                ],
                open: () => {
                    this.bindEvents();
                    this.renderGrid();
                },
                close: () => {
                    this.unbindEvents();
                }
            });

            $('div[role="dialog"]').draggable(constants.DEFAULT_DRAGGABLE_OPTIONS);
        });
    }

    processCustomFonts(){
        const customFonts = this.model.get("customFonts");
        let fontObjects = '';

        if(customFonts.length > 0){
            fontObjects = [];
            customFonts.forEach(font => {

                if (font.name !== "") {
                    let abbr = font.name.toLowerCase().replace(/ /g, '-');
                    fontObjects.push({ name: font.name, value: font.name, abbr: abbr });
                }
            });
            fontObjects = JSON.stringify(fontObjects);        
        }     
        
        return fontObjects;   
    }

    renderGrid(){
        let itemsToRender = this.model.get('customFonts');

        let gridObject = util.getGridObject(this, {
            autowidth: true,
            data: itemsToRender,
            height: 200,
            altRows: true,
            scrollOffset: 0,
            colModel: [{name: "name", index: 'name', editable: true}],
            colNames: ["Font Name"]
        });

        $(constants.PROP_MAIN_TABLE).jqGrid(gridObject);
       
    }

    setSelectedRow(newIndex){
        const rows = $(constants.PROP_MAIN_TABLE).jqGrid('getDataIDs');
        $(constants.PROP_MAIN_TABLE).jqGrid('setSelection', rows[newIndex]);
    }

    afterSaveCell(rowId, cellName, value, iRow, iCol){
        const currentFonts = this.model.get('customFonts');
        currentFonts[iRow - 1].name = value;
        $(constants.PROP_MAIN_TABLE).trigger("reloadGrid");
    }

    onSelectRow(rowId, status, e){
        let input = $(`#${rowId}`).find("input");
        const self = this;

        if(input){
            input.off().on({
                keydown: (evt) => {
                    if (self.charsNotAllowed.includes(evt.key)) {
                        return false;
                    }
                },
                paste: (evt) => {
                    setTimeout(function () {
                        let value = input.val();

                        self.charsNotAllowed.forEach(char => {
                            if (value.indexOf(char)) {
                                value = value.split(char).join('');
                            }
                        });
                        input.val(value);
                    }, 100);
                }
            });
        }
    }

    onCellSelect(){}
    onDoubleClickRow() {}
    setRow(){}

    afterEditCell(rowId, cellName, value, iRow, iCol) {
        $(constants.PROP_MAIN_TABLE).setSelection(rowId);
        $("#" + iRow + "_" + cellName).on('blur', function () {
            $(constants.PROP_MAIN_TABLE).saveCell(iRow, iCol);
        });
    }

    addCustomFont(e){
        const currentFonts = this.model.get('customFonts');  
        const newId = 'jqg' + (currentFonts.length + 1);
        const newGridRow = {name:'New Custom Font', index: newId};
        currentFonts.push(newGridRow);

        $(constants.PROP_MAIN_TABLE).trigger("reloadGrid");
        this.setSelectedRow(currentFonts.length - 1);
    }

    deleteCustomFont(e){
        let myGrid = $(constants.PROP_MAIN_TABLE);
        const selRowId = myGrid.getGridParam('selrow');
        const index = myGrid.getInd(selRowId) - 1;
        
        myGrid.delRowData(selRowId);
        
        const currentFonts = this.model.get('customFonts'); 
        currentFonts.splice(index, 1);
        myGrid.trigger("reloadGrid");
        this.setSelectedRow(currentFonts.length - 1);
    }

    moveItemUp(e){
        let myGrid = $(constants.PROP_MAIN_TABLE);
        const selRowId = myGrid.getGridParam('selrow');
        const index = myGrid.getInd(selRowId) - 1;
        
        if(index > 0){
            const currentFonts = this.model.get('customFonts'); 
            let moved = currentFonts.splice(index, 1);
            currentFonts.splice(index - 1, 0, moved[0]);
            myGrid.trigger("reloadGrid");
            this.setSelectedRow(index - 1);
        }
    }

    moveItemDown(e){
        let myGrid = $(constants.PROP_MAIN_TABLE);
        const selRowId = myGrid.getGridParam('selrow');
        const index = myGrid.getInd(selRowId) - 1;
        const currentFonts = this.model.get('customFonts'); 
            
        if(index < currentFonts.length - 1){
            let moved = currentFonts.splice(index, 1);
            currentFonts.splice(index + 1, 0, moved[0]);
            myGrid.trigger("reloadGrid");
            this.setSelectedRow(index + 1);
        }
    }


    bindEvents() {
        // Binding Dropdown Events
        let dialog = $(constants.DIALOG_ID);
        dialog.css('overflow', 'hidden');
        dialog.find('.itemNew').on('click', e => this.addCustomFont(e));
        dialog.find('.itemRemove').on('click', e => this.deleteCustomFont(e));
        dialog.find('.itemUp').on('click', e => this.moveItemUp(e));
        dialog.find('.itemDown').on('click', e => this.moveItemDown(e));
    }


    unbindEvents() {
        // UnBinding Dropdown Events
        let dialog = $(constants.DIALOG_ID);
        ialog.find('.itemNew').off('click');
        dialog.find('.itemRemove').off('click');
        dialog.find('.itemUp').off('click');
        dialog.find('.itemDown').off('click');
    }

    closeModal() {
        $(constants.DIALOG_ID).dialog("destroy");
        $(constants.DIALOG_ID).remove();
    }
}

export default CustomFontsModalView;